module.exports = __webpack_public_path__ + "static/media/raincoats.78058b28.jpg";